import CustomChip from "../../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status} from "../../../../../enums/statusEnum";
import React, {useState} from "react";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import {NextIconsOptions} from "../../../../../components/buttons/IconButtons";
import routes from "../../../../../Routes/routes";
import {TABLES} from "../../../../../Apis/Tables";
import {useDispatch, useSelector} from "react-redux";
import TableFunction from "../../../../../components/table/TableFunction";
import {
    CRITERIA_MODEL, DEFAULT_LEFT, LEFT_SECOND_COLUMN_WITHOUT_CHECKBOX,
    SEARCH_MODEL,
    WIDTH_COLUMN_FIXED, WIDTH_TOOLTIP_FIXED_COLUMN
} from "../../../../../components/table/Model/TableModel";
import {SearchByFilters, SimpleSearch} from "../../../../../reduxToolkit/Search/SearchApi";
import {INVITATION_VIEW_TYPE, invitationInTime} from "../../Invitation/Model/Model";
import {colors} from "../../../../../enums/colors";
import {EMPTY_VALUES, getFullName} from "../../../../../Apis/functions";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {TABS_VISITOR} from "../../Model/Model";
import {getVisitorTypeName} from "../../Type/Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * RequestInvitationsApp is a functional component that renders the "Requested Invitations" view,
 * handling pagination, filtering, data retrieval, and row actions for visitor invitations.
 *
 * It integrates with Redux for state management, manages UI behavior like expanded rows
 * and selected checkboxes, and supports permission-based rendering of options.
 *
 * @component
 * @param {Object[]} selectedList - Array of currently selected row IDs (used for checkboxes).
 * @param {Function} setSelectedList - Setter function to update the selected list.
 * @param {string} searchElement - Current input string used for searching/filtering data.
 * @param {Object[]} finalArray - Final array of criteria for filter-based search.
 * @param {Function} setSearch - Setter to trigger a new search on criteria change.
 * @param {Function} setCriteria - Setter to define search criteria object.
 * @param {Object} criteria - Current search criteria applied to the table.
 * @param setBodyForExport - Sets the data body for export functionality (required)
 * @param modified
 * @param setModified
 */

export const RequestInvitationsApp =({
                                         selectedList,
                                         setSelectedList,
                                         searchElement,
                                         finalArray,
                                         setCriteria,
                                         setBodyForExport,
                                         modified,
                                         setModified
                                     })=>{
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [results, setResults] = useState(null); // Store the search results
    const option = TABLES.VISITOR_REQUEST;
    const searchId = 'txt_ria_search_requested_invitation';
    const [simpleSearch, setSimpleSearch] = useState(false); // Simple search flag
    const RenderOptionsMenu = (row) => {
        return (

            <>
                {row?.approvalFlowId ? (
                    <DropDownMenuProfile
                        openMenu={openMenu}
                        handleMenuToggle={handleMenuToggle}
                        menuId={`menu-${row.id}`}
                        isAccordion={true}
                    >
                        <DropDownMenuItem
                            id={`btn_ria_approval-tracker${row.id}`}
                            index={row.id}
                            handleClose={handleClose}
                            name={t('approval_tracker')}
                            url={{pathname: `${routes.approvalTracker.main}${TABLES.USER_INVITATION}/${row?.id}/${row?.approvalFlowId}`
                                ,  state: {backUrl:{ pathname: routes.visitor.list, state: { currentTab: TABS_VISITOR.REQUESTS.INDEX, isOverdue: !invitationInTime(row?.endDate) }}}}}
                            icon={<NextIconsOptions />}
                        />
                    </DropDownMenuProfile>
                ) : EMPTY_VALUES.DEFAULT}
            </>
        )
    };

    const handleRowExpand = (row) => {
        if (row?.id !== expandedRowId) {
            setExpandedRowId(row?.id);
        }
    };


    const columns = [
        {
            field: 'hostName',
            label: 'requested_by',
            fixed: true,
            left: DEFAULT_LEFT,
            customWidth: WIDTH_COLUMN_FIXED,
            classNameContainerTooltip: WIDTH_TOOLTIP_FIXED_COLUMN,
            render: (value, row) => getFullName(
                row?.hostName,
                row?.hostLastName,
                row?.hostSecondLastName
            )
        },
        {
            field: 'visitorName',
            label: 'visitor',
            fixed: true,
            left: LEFT_SECOND_COLUMN_WITHOUT_CHECKBOX,
            customWidth: WIDTH_COLUMN_FIXED,
            classNameContainerTooltip: WIDTH_TOOLTIP_FIXED_COLUMN,
            render: (value, row) => getFullName(
                row?.visitorName,
                row?.visitorLastName,
                row?.visitorSecondLastName
            )
        },
        {
            field: 'visitorType.name', label: 'visitor_type',
            render: (value) => {
                return (
                    <CustomChip
                        className={"text-ellipsis"}
                        background={colors.secondary100}
                        fontColor={colors.secondary700}
                        borderColor={colors.secondary150}
                        legend={
                            <CustomTooltip text={getVisitorTypeName(t, value)}>
                                {getVisitorTypeName(t, value)}
                            </CustomTooltip>
                        }
                        variant="large"
                    />
                );
            }
        },
        {
            field: 'approvalStatusId', label: 'approvalStatus',
            render: (value) => {
                return (
                    <CustomChip
                        background={statusColor[value]}
                        fontColor={statusFontColor[value]}
                        borderColor={statusBorderColor[value]}
                        legend={t(status[value]) || EMPTY_VALUES.DEFAULT} variant={'large'}
                    />
                );
            }
        },
    ];

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, viewType: INVITATION_VIEW_TYPE.REQUESTED_INVITATIONS, key:searchElement});
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page) => {
        const body = SEARCH_MODEL.setObject({
            page,
            size:rowsPerPage,
            model:option,
            rootGroup: CRITERIA_MODEL.set(finalArray),
            viewType: INVITATION_VIEW_TYPE.REQUESTED_INVITATIONS
        });
        setCriteria(body);
        dispatch(SearchByFilters({ option, body })).then(({ payload: {data: { data }}}) => {
            setResults(data);
        });
    }

    // Use the TableFunction SubComponents to handle table logic (checkbox selection, pagination, etc.)
    const { t, handleCheckboxChange, handleDeleteAll, pagination, page, rowsPerPage,
        openMenu, handleMenuToggle, handleClose} = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        labelRowsPerPage: 'invitation_per_page',
        hasContainer: true,
        fixedPagination: false,
        setIsAllChecked,
        searchElement,

        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advanced search
        finalArray,//New - apply only with advanced search
    });

    return {
        columns,
        handleRowExpand,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        results,
        DEV,
        permission,
        setResults,
        option,
        page,
        rowsPerPage,
        userId : user.id,
        RenderOptionsMenu,
        searchId,
        setSimpleSearch,
        t
    }
}
